import {DataModificationsHeader} from 'audit/DataModifications';
import type {StoichiometryGroup} from 'notebook/integrations/chemistry/StoichiometryTypes';
import {clientId} from 'notebook/store/VersioningConstants';
import {ActionFunctionContext} from 'notebook/structured-tables/action-functions/ActionFunctionContext';
import {getLatestVersionId} from 'notebook/structured-tables/ActionFunctionDAO';
import {EvaluatedCell} from 'notebook/tables/excess/EvaluationConstants';
import * as net from 'util/Net';

export interface ReactionGroupResponse {
  reactionId: string;
}

export function submitReactionGroup(
  entryId: string,
  stoichiometryGroup: StoichiometryGroup,
  evaluatedTableMap: {[tableName: string]: Array<Array<EvaluatedCell>>},
  actionFunctionContext: ActionFunctionContext,
  extraParams?: {folderId?: string; reactionName?: string},
  dataModsHeader?: DataModificationsHeader,
  latestVersionId?: number
): Promise<ReactionGroupResponse> {
  const resolvedLatestVersionId = latestVersionId ?? getLatestVersionId(entryId);
  return net.postJSONPromise({
    url: `/1/api/entries/${entryId}/note-linked-groups/${stoichiometryGroup.provenanceUuid}/action/reaction-submit`,
    data: {
      evaluatedTableMap,
      actionFunctionContext,
      clientId,
      latestVersionId: resolvedLatestVersionId,
      ...extraParams,
    },
    extraHeaders: dataModsHeader,
  });
}
